export default "__VITE_ASSET__CpPS6p20__"